import React from 'react';
import { Table, Tooltip, Button, Input, Row, Col, Icon, Spin, Tag, Select } from 'antd';
import { openNotification } from '../../util/notificaciones';
import FormMinimosEstandares from './FormMinimosEstandares';
import MinimosEstandaresRequest from '../../services/MinimosEstandares';
import CatalogosRequest from '../../services/Catalogos';
import { sanitizerTexto } from '../../util/utilerias';
import ArticulosRequest from '../../services/Articulos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { Search } = Input;

/**
 * Clase para módulo de catálogo Oxxo
 */
export default class MinimosEstandares extends BaseComponent {
    state = {
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrSegmentos: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        segmentoSelected: null,
        drivesSelected: [],
        searchNameProducto: "",
        arrArticulosMinimos: [],
        arrArticulosMinimosCopy: [],
        estatusSelected: null,
        maquinaSelected: null,
        disableDeleteFilters: true,
        pagination: {},
        cargando: false,
        typeForm: null,
        objArticulo: null,
        visible: false,
        disableApplyFilters: true,
        disableCreateMinimo: true,
        arrArticulosBusqueda: [],
        valueBuscarArt: null,
        articuloSelectedEq: null,
        selectedRowKeys: [],
        selectedRows: [],
    }

    /**
     * Cargar datos cuando entra al módulo
     */
    componentDidMount = () => {
        let state = { ...this.state }
        state.selectedRowKeys = [];
        state.selectedRows = [];
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                return CatalogosRequest.ListarSegmentosConfigurados()
            })
            .then(response => {
                state.arrSegmentos = response.data;
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Cargar datos de los productos
     */
    cargarProductos = () => {
        let state = { ...this.state }
        state.cargando = true
        state.searchNameProducto = "";
        state.estatusSelected = null;
        state.disableCreateMinimo = false;
        let obj_enviar = {}
        obj_enviar.sitios = state.drivesSelected;
        obj_enviar.articulo_id = state.articuloSelectedEq;
        state.selectedRowKeys = [];
        state.selectedRows = [];
        this.setState(state, () => {
            MinimosEstandaresRequest.ListarMinimosEstandar(obj_enviar)
                .then(response => {
                    state.arrArticulosMinimos = response.data;
                    state.arrArticulosMinimosCopy = response.data;
                    state.cargando = false;
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(err?.response?.data?.cuerpo, err?.response?.data?.titulo, false)
                })
        })
    }

    /**
     * Filtrar entre los resultados según los valores establecidos en los filtros
     * @return: nada
     */
    handleSearchInput = (value) => {
        let state = { ...this.state }
        state.searchNameProducto = value;
        this.setState(state, this.applyFilters)
    }

    /**
     * Filtrar entre los resultados según los valores establecidos en los filtros
     * @return: nada
     */
    onChangeEstatus = (value) => {
        let state = { ...this.state }
        state.estatusSelected = value
        this.setState(state, this.applyFilters)
    }

    /**
     * Filtrar entre los resultados según los valores establecidos en los filtros
     * @return: nada
     */
    applyFilters = () => {
        let state = { ...this.state }
        let arrArticulosMinimosCopy = state.arrArticulosMinimos;
        let activo = state.estatusSelected === 1 ? true : state.estatusSelected === 2 ? false : null
        if (state.searchNameProducto) {
            arrArticulosMinimosCopy = arrArticulosMinimosCopy.filter(obj => {
                return sanitizerTexto(state.searchNameProducto, obj?.maquina ?? null)
                    || sanitizerTexto(state.searchNameProducto, obj?.articulo?.codigo ?? null)
                    || sanitizerTexto(state.searchNameProducto, obj?.articulo?.descripcion ?? null)
            })
        }

        if (state.estatusSelected) {
            arrArticulosMinimosCopy = arrArticulosMinimosCopy.filter(item => {
                return item.activo === activo
            });
        }

        if (state.searchNameProducto.trim() === '' && (state.estatusSelected === null || state.estatusSelected === undefined)) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        state.arrArticulosMinimosCopy = arrArticulosMinimosCopy;
        this.setState(state)
    }

    /**
     * Mostrarl el modal de formulario de productos
     * @param: type. acción que elige el usuario entre ver, editar o nuevo
     * @return: nada, se usa el valor para mostrar datos específicos
     */
    showForm = (type, value, record) => {
        this.setState({ typeForm: type, objArticulo: record, visible: true })
    }

    /**
     * Función que se encarga cancelar modal
     */
    cancelModal = (value) => {
        let state = { ...this.state };
        state.visible = false;
        state.objArticulo = null;
        this.setState(state)
        if (value) {
            this.cargarProductos();
        }
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.searchNameProducto = '';
        state.estatusSelected = undefined;
        state.segmentoSelected = null;
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        state.arrArticulosBusqueda = [];
        state.articuloSelectedEq = null;
        state.valueBuscarArt = null;
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.disableApplyFilters = true;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.segmentoSelected = null;
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.segmentoSelected = null;
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
        }

        this.setState(state)
    }

    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.filterText = "";
        state.disableApplyFilters = true
        state.disableCreateMinimo = true;
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value
            if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            } else {
                CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        state.disableCreateMinimo = true;
        state.arrArticulosBusqueda = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.articuloSelectedEq = null;
        state.valueBuscarArt = null;
        if (!value.length) {
            state.drivesSelected = [];
            state.disableApplyFilters = true
        } else {
            state.drivesSelected = value
            if (value.length > 1) {
                state.disableApplyFilters = true
            } else {
                state.disableApplyFilters = false
                state.disableCreateMinimo = false;
            }
        }

        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en buscar en input search
     * @param: value. valor del input search
     * @return: nada.
     */
    buscarArticulo = (value) => {
        let state = { ...this.state }
        let filtros = {}
        if (value.trim()) {
            filtros.filtro = value
            this.setState({ cargando: true }, () => {
                ArticulosRequest.ListarArticulos(filtros)
                    .then(response => {
                        state.arrArticulosBusqueda = response.data.results
                        state.cargando = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.cuerpo, false)
                    })
            })
        }
    }

    handleChangeArticulo = (value) => {
        let state = { ...this.state };
        state.articuloSelectedEq = value;
        state.disableApplyFilters = value ? false : true
        state.disableCreateMinimo = value ? false : true
        this.setState(state)
    }

    /**
    * Funcion interna de ant para el manejo de los checkbox
    * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
    * @return: nada
    */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        let disabled = selectedRowKeys.length > 1 ? true : false
        this.setState({ selectedRowKeys, selectedRows, disableCreateMinimo: disabled });
    };

    render() {
        const columnsArticulosMinimos = [
            {
                title: "Sitio",
                dataIndex: "sitio_nombre",
                key: "sitio_nombre",
            },
            {
                title: "Código",
                dataIndex: "articulo.codigo",
                key: "articulo.codigo",
            },
            {
                title: "Decripción",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion",
            },
            {
                title: "Máquina",
                dataIndex: "maquina",
                key: "maquina",
            },
            {
                title: "Unidad de medida",
                dataIndex: "articulo.unidad_compra",
                key: "articulo.unidad_compra",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
            },
            {
                title: "Activo",
                dataIndex: "activo",
                key: "activo",
                render: activo => (
                    <Tag color={activo ? "blue" : "red"}>
                        {activo ? "Activo" : "Inactivo"}
                    </Tag>
                )
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span className={this.state.drivesSelected.length > 1 ? 'display-none' : ''} style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar artículo"}>
                                <Button icon="edit" className="btnEditar" onClick={() => this.showForm(2, value, record)}></Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ]
        const selectedRowKeys = this.state.selectedRowKeys;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        this.setState({
                            selectedRowKeys: this.state.arrArticulosMinimos.map(item => item.id),
                            selectedRows: [...this.state.arrArticulosMinimosCopy]
                        });
                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                },
            ],
            getCheckboxProps: record => ({
                className: (this.state.articuloSelectedEq) ? '' : 'display-none',
                disabled: (this.state.articuloSelectedEq) ? false : true,
            }),
        };
        const searchButtons = <>
            <Col span={this.state.isPos ? 3 : 2}>
                <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                    <Button
                        id="boton-filtrar-prductos-minimo"
                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                        type={this.state.disableApplyFilters ? "default" : "primary"}
                        icon="search"
                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                        onClick={this.cargarProductos}
                    >
                    </Button>
                </Tooltip>
            </Col>
            <Col span={this.state.isPos ? 3 : 2}>
                <Tooltip placement="top" title="Borrar filtros">
                    <Button
                        id="boton-borrar-filtros-prductos-minimo"
                        type="default"
                        icon="delete"
                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                        onClick={this.cleanFilters}
                    >
                    </Button>
                </Tooltip>
            </Col>
        </>
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo de Mínimos Estándares"
                className="title-card"
                extra={
                    <div>
                        <Button
                            style={{marginRight:'15px'}}
                            className={this.state.selectedRowKeys.length > 1 ? 'btnVerCrearGuardar' : 'display-none'}
                            disabled={this.state.selectedRowKeys.length < 2}
                            type="primary"
                            onClick={() => this.showForm(1, undefined, undefined)}
                        >
                            Edición Masiva
                        </Button>
                        <Button
                            className="btnVerCrearGuardar"
                            disabled={this.state.disableCreateMinimo}
                            type="primary"
                            onClick={() => this.showForm(1, undefined, undefined)}
                        >
                            Nuevo Mínimo Estándar
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div className="filters">
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected === null ? true : false}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null ? true : false}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Segmento:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione un segmento">
                                    <Select
                                        id="select-segmento-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeSegmento}
                                        value={this.state.segmentoSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Punto de venta:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione punto de venta">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            { this.state.drivesSelected?.length < 2 ? searchButtons : ''}
                            <Col className={this.state.drivesSelected?.length > 1 ? '' : 'display-none'} span={8}>
                                <div className="center">Buscar artículo:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar artículo">
                                    <Search
                                        value={this.state.valueBuscarArt}
                                        id="input-search-articulo-equivalencia-nueva-forma"
                                        placeholder="Ingrese Código / Descripción"
                                        enterButton="Buscar"
                                        onChange={(e) => this.setState({ valueBuscarArt: e.currentTarget.value })}
                                        onSearch={value => { this.buscarArticulo(value) }}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row gutter={12}>
                            <Col className={this.state.drivesSelected?.length > 1 ? '' : 'display-none'} style={{marginBottom: 20}} span={8}>
                                <div className="center">Seleccionar artículo:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione artículo">
                                    <Select
                                        allowClear={true}
                                        id="select-articulo-form-articulo-equivalencias"
                                        className={(!this.state.arrArticulosBusqueda?.length) ? 'disableInputText' : ''}
                                        disabled={(!this.state.arrArticulosBusqueda?.length) ? true : false}
                                        defaultActiveFirstOption={false}
                                        style={{ width: "100%" }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        onChange={this.handleChangeArticulo}
                                        value={this.state.articuloSelectedEq}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrArticulosBusqueda?.length > 0 &&
                                            this.state.arrArticulosBusqueda?.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj?.id}
                                                        value={obj?.id}>
                                                        {obj?.codigo_descripcion}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            { this.state.drivesSelected?.length > 1 ? searchButtons : ''}
                        </Row>
                        <Row gutter={8} className={this.state.arrArticulosMinimos.length ? '' : 'display-none'} style={{ marginBottom: 20}}>
                            <Col span={8} >
                                <Tooltip placement="top" title="Buscar sobre todos los resultados">
                                    <div className="center">Búsqueda:</div>
                                    <Input
                                        id="tabla-input-buscar-articulos-minimos"
                                        type="text"
                                        maxLength={80}
                                        value={this.state.searchNameProducto}
                                        autoFocus={true}
                                        placeholder="Buscar por Código / Descripción / Máquina"
                                        onChange={(e) => this.handleSearchInput(e.currentTarget.value)}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={8} >
                                <Tooltip placement="top" title="Buscar artículo por estatus">
                                    <div className="center">Estatus artículo:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        defaultActiveFirstOption={false}
                                        value={this.state.estatusSelected}
                                        onChange={this.onChangeEstatus}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        <Option key={1} value={1}>Activo</Option>
                                        <Option key={2} value={2}>Inactivo</Option>
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={articulo => articulo.id}
                            pagination={this.state.pagination}
                            columns={columnsArticulosMinimos}
                            dataSource={this.state.arrArticulosMinimosCopy}
                            rowSelection={rowSelection}
                        />
                    </Spin>
                    <FormMinimosEstandares
                        visible={this.state.visible}
                        cancel={this.cancelModal}
                        articulo={this.state.objArticulo}
                        drive_selected={this.state.drivesSelected}
                        articulo_selected={this.state.articuloSelectedEq}
                        rows_selected={this.state.selectedRows}
                        type={this.state.typeForm}
                    />
                </div>
            </ResponsiveCard>
        )
    }
}